import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
// import photo from '../../assets/profile-pic.png'
import { singleUser } from '../helpers/links'

const User = ({ star, position, starWidth }) => {
  // console.log(star)
  const [hover, setHover] = useState(false)
  const showTweet = (bool) => {
    setHover(bool)
  }

  const { username, response } = star

  const insetStyle = {
    backgroundImage: `url(${response.data.user.display_picture})`,
    backgroundColor: `#ff5c00`,
    width: `${starWidth - 10}px`,
    height: `${starWidth - 10}px`,
  }

  const usernameStyle = {
    transform: `translateY(${starWidth / 2 + starWidth / 8}px)`,
  }

  return (
    <NavLink to={`${singleUser}/${username}`} className="user" style={position}>
      <div className="user_inner" style={insetStyle} onMouseOver={() => showTweet(true)} onMouseOut={() => showTweet(false)} />
      <div style={usernameStyle} className="user_display-name">
        {hover && <p>@{response.data.user.username}</p>}
      </div>
    </NavLink>
  )
}

export default User
